import request from '@/axios'


export function create_subject (school_id, query) {
  return request({
    url: `/subjects/create/${school_id}`,
    method: 'POST',
    data: query
  })
}
export function list_subject (school_id, quaryParams, payload,query={}) {
  let url=''
  if(query.length > 0){
    url=`/subjects/list/${school_id}?attribute=${query.attribute}&direction=${query.direction}&field_type=${query.field_type}&page=${quaryParams}`
  } else {
    url=`/subjects/list/${school_id}?page=${quaryParams}`
  }
  return request({
    url,  
    method: 'POST',
    data: payload
  })
}

export function subject_update (school_id, subject_id, payload) {
  // 
  return request({
    url: `/subjects/edit/${school_id}/${subject_id}`,
    method: 'PUT',
    data: payload
  })
}

export function delete_subject (school_id, subject_id) {
  // 
  return request({
    url: `/subjects/delete/${school_id}/${subject_id}`,
    method: 'GET'
  })
}

export function checkingSubjectAssociaton (platform_customer_id, subject_id) {
  // 
  return request({
    url: `subjects/checkAssociation/${platform_customer_id}/${subject_id}`,
    method: 'GET'
  })
}

